<template>
  <div>
    <Breadcrumb :options="breadcrumb" />

    <div class="fillet">
      <div class="retrieval">
        <!-- 表头设置控件 -->
        <div class="right">
          <TableHeadSelect :config="formCtrlRight" :options="formCtrlRight.options" :inputValue="defaultTh"
            @onChange="onTableSelect" />
        </div>
      </div>
    </div>

    <Table ref="table" :tableData="tableData" :cols="cols" :btns="btns" :page="page" :limit="limit" :total="total" :showTotal="true"
      :getTotal="getTotal" @onSelectionChange="onSelectionChange" @onCurrentChange="onCurrentChange"
      @onSizeChange="onSizeChange">
      <template slot="status" slot-scope="params">
        <span v-if="params.params.status == 1">申请报销</span>
        <span v-if="params.params.status == 2">已批准</span>
        <span v-if="params.params.status == 3">已报销</span>
      </template>
    </Table>
  </div>
</template>

<script>
import tableMixin from "../../mixin/table";

export default {
  mixins: [tableMixin],
  data() {
    return {
      baseUrl: 'repair',
      breadcrumb: [
        { name: "财务管理", path: "/finance/captainSalary" },
        { name: "车队长工资表", path: "/finance/captainSalary" },
        { name: "当月维保记录" },
      ],
      cols: [
        { keyName: "license", label: "车牌号", minwidth: 120 },
        { keyName: "driver", label: "司机姓名" },
        { keyName: "rstarttime", label: "维保时间", minwidth: 120 },
        { keyName: "repair", label: "维保项目", minwidth: 120 },
        { keyName: "money", label: "维保金额", align: 'right', className: 'pr30', minwidth: 120 },
        { keyName: "status", label: "审批状态", slot: 'status' },
      ],
      baseParams: ['month', 'fleet'],
      getTotalProperty: ['money'],
    };
  },
  methods: {},
  mounted() {
    this.setQueryParams();
    this.$nextTick(this.getList);
  },
};
</script>

<style lang="less" scoped>
.fillet {
  height: auto;
  margin: 0 auto;
  padding: 0 0 10px;
  border-radius: 5px;
  box-shadow: 0px 0px 10px rgb(0 0 0 / 3%);

  .retrieval {
    height: 52px;
    /* overflow: hidden; */
    margin: 0px 20px;
    font-size: 14px;
    color: #606266;
    // display: flex;
    // justify-content: space-between;
    position: relative;

    .right {
      position: absolute;
      right: 10px;
    }
  }
}
</style>
